import React from "react";
import ReactDOM from "react-dom";
import store from "./helpers/store";
import { saveAuthState } from "./helpers/localStorage";
import { logout, updateLocalToken } from "./features/login/loginSlice";
import { loginServices } from "./services/login.services";
import { StorageKeys } from "./services/constants";
import "./index.css";
import "./i18n";
import App from "./features/app/App";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/core/styles";
import reportWebVitals from "./reportWebVitals";
import { initialize } from "./features/app/asyncThunkActions";
import { BrowserRouter as Router } from "react-router-dom";
import createAppTheme from "./styles/createAppTheme";
import { ReducerStates } from "./helpers/constants";

// Material UI Theme for StackCare App
const theme = createAppTheme();

// Initialize app
store.dispatch(initialize());

// Subscribe and synchronize auth state and selected community in local storage
let savedAuthState = localStorage.getItem(StorageKeys.USER);

store.subscribe(() => {
  const state = store.getState();
  if (state.appState.state !== ReducerStates.SUCCEEDED) {
    return;
  }

  const token = state.loginState.userToken;
  const nextAuthState = token?.refresh_expiration
    ? JSON.stringify(token)
    : null;

  if (nextAuthState !== savedAuthState) {
    saveAuthState(token);
    savedAuthState = nextAuthState;
  }
});

window.addEventListener("storage", (event) => {
  if (event.storageArea !== localStorage || event.key !== StorageKeys.USER) {
    return;
  }

  savedAuthState = event.newValue;

  if (event.newValue === null) {
    store.dispatch(logout());
    loginServices.logoutFirebase();
    return;
  }

  try {
    store.dispatch(updateLocalToken(JSON.parse(event.newValue)));
  } catch (err) {
    store.dispatch(logout());
    loginServices.logoutFirebase();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Router>
          <App />
        </Router>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
